<template>
  <b-modal
    id="vacina-modal"
    :title="title"
    v-model="innerShow"
    :modal-class="'modal-zindex-top'"
    centered
    scrollable
    hide-footer
    @shown="prefill"
    @hidden="resetForm"
  >
    <ValidationObserver ref="observer" class="row">
      <div class="col-lg-6">
        <validation-provider v-slot="{ errors }" rules="required">
          <div class="mb-2">
            <the-mask
              :mask="['##/##/####']"
              v-model="form.dataAplicacao"
              required
              class="form-control"
              placeholder="Data da aplicação"
              :disabled="btn.loading || !podeEditar"
            />
          </div>
          <div class="error">{{ errors[0] }}</div>
        </validation-provider>
      </div>

      <div class="col-lg-6">
        <validation-provider v-slot="{ errors }" rules="required">
          <div class="mb-2">
            <input
              name="lote"
              v-model="form.lote"
              class="form-control"
              placeholder="Lote"
              type="text"
              required
              :disabled="btn.loading || !podeEditar"
            />
          </div>
          <div class="error">{{ errors[0] }}</div>
        </validation-provider>
      </div>

      <div class="col-lg-12">
        <button
          class="btn mt-2"
          :disabled="btn.loading || !podeEditar"
          @click="submit"
        >
          {{ mode === 'edit' ? 'Atualizar' : 'Salvar' }}
          <b-spinner small variant="white" v-if="btn.loading" />
        </button>
      </div>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { TheMask } from 'vue-the-mask'
import utils from '@/mixins/utils'

export default {
  name: 'SalvarVacinaModal',
  components: { ValidationObserver, ValidationProvider, TheMask },
  props: {
    value: { type: Boolean, default: false }, // v-model
    title: { type: String, default: 'Vacina' },
    item: { type: Object, default: null },
    dose: { type: Object, default: null },
    mode: { type: String, default: 'create' },
  },
  mixins: [utils],
  data() {
    return {
      form: {
        dataAplicacao: null,
        lote: null,
      },
      btn: { loading: false },
      podeEditar: true,
    }
  },
  computed: {
    innerShow: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    /**
     * Preenche o formulário com os dados da dose em modo de edição.
     */
    async prefill() {
      this.podeEditar = true

      if (this.mode !== 'edit') return
      if (!this.dose) return

      const orig = this.dose?.orig

      // só edita se orig == 3
      if (String(orig ?? '') !== '3') {
        this.podeEditar = false
      }

      // lote
      if (this.dose?.lt != null && String(this.dose.lt).trim() !== '') {
        this.form.lote = this.dose.lt
      } else {
        this.form.lote = null
      }

      // data aplicação
      if (this.dose?.dt_plc != null && String(this.dose.dt_plc).trim() !== '') {
        this.form.dataAplicacao = this.formatDate(this.dose.dt_plc)
      } else {
        this.form.dataAplicacao = null
      }
    },

    /**
     * Reseta os campos e o estado do formulário.
     */
    resetForm() {
      this.form.dataAplicacao = null
      this.form.lote = null
      this.btn.loading = false
      this.podeEditar = true
    },

    /**
     * Busca o CPF do profissional autenticado.
     * @returns {String|null} CPF do profissional
     */
    async getCpfProfissional() {
      const res = await this.$api.post('/app/auth/usuario', {
        cod_ibge: this.$store.state.cod_ibge,
        id: this.$store.state.id,
      })

      const cpf = res?.data?.cpf
      if (!cpf) {
        return null
      }

      return cpf
    },

    /**
     * Valida e envia os dados da vacina para salvamento.
     */
    async submit() {
      try {
        if (!this.podeEditar) return

        if (this.item == null) return

        const isValid = await this.$refs.observer.validate()
        if (!isValid) return
        if (!this.dose) return

        this.btn.loading = true

        const cpfProfissional = await this.getCpfProfissional()
        if (!cpfProfissional) return

        const dtIso = this.converterParaDataIso(this.form.dataAplicacao)
        const lote = this.form.lote

        const payload = {
          co_ibge: this.$store.state.cod_ibge,
          cfcp: this.item.cfcp,
          nu_cns: this.item.nu_cns,
          nu_cpf: this.item.nu_cpf,
          cpf_profissional: cpfProfissional, // profissional logado
          id_imunobiologico: this.dose.id_mn,
          id_dose_imunobiologico: this.dose.id_ds,
          lote,
          dt_aplicacao: dtIso,
        }

        const response = await this.$api.post('/app/efb-vacina', payload)

        if (!response) return

        if (response.data?.error === false) {
          this.$toast.success(
            this.mode === 'edit'
              ? 'Vacina atualizada!'
              : 'Vacina salva com sucesso!',
            'Sucesso:',
            { position: 'topRight' }
          )

          this.innerShow = false

          const payload = { item: this.item, dose: this.dose, dtIso, lote }
          this.$emit(this.mode === 'edit' ? 'updated' : 'saved', payload)
        } else {
          this.$toast.error(
            response.data?.message || 'Erro ao salvar vacina!',
            'Erro:',
            {
              position: 'topRight',
            }
          )
        }
      } catch (e) {
        console.log(e)
        this.$toast.error('Erro ao salvar vacina!', 'Erro:', {
          position: 'topRight',
        })
      } finally {
        this.btn.loading = false
      }
    },
  },
}
</script>

<style></style>
